























































































import Component from "vue-class-component";
import Vue from "vue";

@Component
export default class Navigation extends Vue {
  private isMounted = false;

  mounted() {
    setTimeout(() => (this.isMounted = true), 2000);
  }
}
